/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Cookies from 'components/common/utils/cookies'
import { useSelector, useDispatch } from 'react-redux'
import { axiosRefresh } from 'api/auth'

import Loader from 'components/common/Loader'
import Routes from 'components/Routes/Routes'
import { constantAll } from 'api/constants'
import { setOptions } from 'redux/info-slice'
import { transformForSelect } from 'components/Routes/PrivateRoutes'


const PublicRoute = () => {
  const dispatch = useDispatch()

  const [isReady, setIsReady] = useState(false)

  const { isLogin } = useSelector((state) => state.auth)

  const token = Cookies.get(window._env_.REACT_APP_TOKEN_KEY)
  const userRole = Cookies.get(window._env_.REACT_APP_USER_ROLE_KEY)
  const isAccesInCookies = token && userRole

  const get_constants = async () => {
    try {
      const data = await constantAll()
      if (data.status === 'success') {
        const res = data.data

        const apiConstants = {
          verticals: transformForSelect(res.verticals),
          geos: transformForSelect(res.geos),
          trafficSources: transformForSelect(res.traffic),

          country_code_phone: transformForSelect(
            res.country_code_phone,
            'prefix',
          ),
        }

        dispatch(setOptions(apiConstants))
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsReady(true)
    }
  }

  useEffect(() => {
    get_constants()

    if (!token) return
    axiosRefresh(token)
  }, [])

  if (isLogin || isAccesInCookies) {
    return <Navigate to={Routes.getUrl(Routes.dashboard.index)} />
  }

  if (!isReady) return <Loader />

  return !isAccesInCookies ? <Outlet /> : <Loader />
}

export default PublicRoute
